import React from 'react';
import {
  inputFieldClassName,
  inputPremiumClassName,
  searchInputClassName,
  textareaFieldClassName,
  inputClassWithError,
} from './formStyles';

const VARIANT_CLASSES = {
  field: inputFieldClassName,
  premium: inputPremiumClassName,
  compact: searchInputClassName,
  textarea: textareaFieldClassName,
};

function Input({
  variant = 'field',
  error = false,
  as,
  className = '',
  ...props
}) {
  const isTextarea = as === 'textarea' || variant === 'textarea';
  const Component = isTextarea ? 'textarea' : 'input';

  let classes;
  if (variant === 'validated') {
    classes = inputClassWithError(error, className);
  } else {
    const base = VARIANT_CLASSES[variant] || inputFieldClassName;
    classes = `${base} ${className}`.trim();
  }

  return <Component className={classes} {...props} />;
}

export default Input;
